import codeMirror from 'codemirror';
import 'codemirror/mode/htmlmixed/htmlmixed';

import 'codemirror/lib/codemirror.css';
import 'froala-editor/js/plugins/align.min';
import 'froala-editor/js/plugins/code_view.min';
import 'froala-editor/css/plugins/code_view.min.css';
import 'froala-editor/js/plugins/colors.min';
import 'froala-editor/css/plugins/colors.min.css';
import 'froala-editor/js/plugins/font_family.min';
import 'froala-editor/js/plugins/font_size.min';
import 'froala-editor/js/plugins/link.min';
import 'froala-editor/js/plugins/lists.min';
import 'froala-editor/js/plugins/track_changes.min';
import 'froala-editor/js/plugins/code_beautifier.min';

// we iframe the editor to avoid any global base styles causing trouble
// anything in here is a default that users can override with their own changes
const editorStyle = `
  body {
    font-family: sans-serif;
    font-size: 14px;
    overflow: hidden;
  }
  .fr-box.fr-basic .fr-element.fr-view {
    font-size: 14px;
    font-family: sans-serif;
  }
`;

const config = {
  attribution: false,
  codeMirror,
  codeMirrorOptions: {
    indentWithTabs: true,
    lineNumbers: true,
    lineWrapping: true,
    mode: 'text/html',
    tabMode: 'indent',
    tabSize: 2,
  },
  codeViewKeepActiveButtons: ['fieldReplacement'],
  fontFamily: {
    Serif: 'Serif',
    Sans: 'Sans',
    Arial: 'Arial',
    'Arial Black': 'Arial Black',
    Courier: 'Courier',
    'Courier New': 'Courier New',
    'Comic Sans MS': 'Comic Sans MS',
    Helvetica: 'Helvetica',
    Impact: 'Impact',
    'Lucida Grande': 'Lucida Grande',
    'Lucida Sans': 'Lucida Sans',
    Tahoma: 'Tahoma',
    Times: 'Times',
    'Times New Roman': 'Times New Roman',
    Verdana: 'Verdana',
  },
  heightMin: 500,
  heightMax: 500,
  htmlUntouched: true,
  iframe: true,
  iframeDefaultStyle: editorStyle,
  placeholderText: '',
  toolbarButtons: [
    [
      'fontFamily',
      '|',
      'fontSize',
      '|',
      'bold',
      'italic',
      'strikeThrough',
      'underline',
      '|',
      'textColor',
      'backgroundColor',
      '|',
      'formatOL',
      'formatUL',
      'indent',
      'outdent',
      '-',
      'alignLeft',
      'alignCenter',
      'alignRight',
      'alignJustify',
      '|',
      'insertLink',
      '|',
      'undo',
      'redo',
      '|',
      'html',
      '|',
      'fieldReplacement',
    ],
  ],
  events: {
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    initialized() {
      this.size.syncIframe();
    },
  },
};

export default config;

export const htmlOnlyOverrides = {
  ...config,
  toolbarButtons: ['fieldReplacement'],
  events: {
    /* oxlint-disable object-shorthand */
    ...config.events,
    initialized: function () {
      this.codeView.toggle();
    },
  },
};
